export default __webpack_public_path__ + "static/media/philosophy.1268d73a.jpg";